module.exports = __webpack_public_path__ + "static/media/status_failed.23f55ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/status_failed.jpg
// module id = 1884
// module chunks = 0